import { create } from 'zustand';
import { Drama } from '../component/Slider';

interface TrendingState {
    trending: string[];
    isLoading: boolean;
    isFetched: boolean;
    fetchTrending: () => Promise<void>;
}

async function fetchTrendingData() {
    try {
        const res = await fetch(`https://dramasstory.com/web/search_suggestion.php?lc=en`);
        const data = await res.json();
        return data?.data?.Data[0].list || [];
    } catch (error) {
        console.error('Error fetching trending data:', error);
        return [];
    }
}

export const useTrendingStore = create<TrendingState>((set, get) => ({
    trending: [],
    isLoading: false,
    isFetched: false,
    fetchTrending: async () => {
        const { isFetched, isLoading } = get();
        
        // Don't fetch if already fetched or currently loading
        if (isFetched || isLoading) {
            return;
        }

        set({ isLoading: true });
        
        try {
            const data = await fetchTrendingData();

            const trendingNames = data.map((item: Drama) => item.d_name) || [];
            
            set({ 
                trending: trendingNames, 
                isLoading: false, 
                isFetched: true 
            });
        } catch (error) {
            console.error('Error in fetchTrending:', error);
            set({ isLoading: false });
        }
    },
}));